export default __webpack_public_path__ + "static/media/Q0000.c53dc359.png";